import { NgClass } from '@angular/common';
import { Component, input, output } from '@angular/core';
import { LucideAngularModule } from 'lucide-angular';

@Component({
  selector: 'app-ui-button',
  imports: [NgClass, LucideAngularModule],
  templateUrl: './ui-button.html',
  styleUrl: './ui-button.css',
})
export class UiButton {
// Inputs usando Signals
  variant = input<'primary' | 'secondary' | 'danger' | 'soft' | 'neutral'>('primary');
  disabled = input(false);
  loading = input(false);
  icon = input<string>();
  iconSize = input<string>('h-5 w-5 sm:h-6 sm:w-6');

  // Output (nuevo formato Angular 17+)
  buttonClick = output<void>();

  handleClick(_event: MouseEvent) {
    // Prevenir el comportamiento por defecto si es necesario,
    // pero permitimos que el evento burbujee
    if (!this.disabled() && !this.loading()) {
      this.buttonClick.emit();
    }
  }

  getClasses() {
    const variants = {
      primary: 'bg-[#0054a6] hover:bg-[#003b74] text-white h-14 sm:h-16 px-6 sm:px-8 text-base sm:text-lg gap-3 transition-colors touch-target flex items-center justify-center rounded',
      secondary: 'bg-white text-[#0054a6] border border-[#0054a6]/30 hover:bg-[#f2f2f2] hover:border-[#0054a6]/50 h-14 sm:h-16 px-6 sm:px-8 text-base sm:text-lg gap-3 transition-colors touch-target flex items-center justify-center rounded',
      danger: 'bg-red-600 hover:bg-red-700 text-white h-14 sm:h-16 px-6 sm:px-8 text-base sm:text-lg gap-3 transition-colors touch-target flex items-center justify-center rounded',
      soft: 'bg-[#eaf3ff] text-[#0054a6] border border-[#b7d3f2] hover:bg-[#dcecff] hover:border-[#8fb8e6] h-14 sm:h-16 px-6 sm:px-8 text-base sm:text-lg gap-3 transition-colors touch-target flex items-center justify-center rounded',
      neutral: 'bg-white text-[#5f6b7a] border border-[#d5dbe3] hover:bg-[#f7f9fb] hover:border-[#bec9d6] h-14 sm:h-16 px-6 sm:px-8 text-base sm:text-lg gap-3 transition-colors touch-target flex items-center justify-center rounded'
    };

    return variants[this.variant()];
  }
}
